import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FunctionComponent, useState } from 'react';
import styles from './PaidIcon.module.scss';

interface PaidIconProps {
    paid: boolean;
    className?: string;
}

export const PaidIcon: FunctionComponent<PaidIconProps> = props => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div
            className={styles.container}
            onMouseLeave={() => setShowTooltip(false)}
            onMouseEnter={() => setShowTooltip(true)}
        >
            {props.paid && showTooltip && (
                <div className={styles.tooltipContainer}>
                    <span className={styles.tooltipText}>Paid</span>
                </div>
            )}
            {props.paid && (
                <FontAwesomeIcon
                    icon={faCircleCheck}
                    color="#5E8677"
                    fontSize={18}
                />
            )}
        </div>
    );
};

export default PaidIcon;
